/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
export default class FreestyleUsageBasicCssVariableComponent extends Component {
  get shouldRenderDefaultValue() {
    return this.args.defaultValue !== undefined;
  }
  get shouldRenderDefaultComputed() {
    const {
      defaultValue
    } = this.args;
    return defaultValue?.computed !== undefined && defaultValue.computed !== defaultValue.raw;
  }
}